import { Theme } from "@mui/material";

export default function Table(theme: Theme) {
  return {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          position: "relative",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          // borderBottom: "none",
          ...theme.typography.body3,
          padding: "8px 16px"
        },
        head: {
          fontWeight: 600,
          borderBottom: "none",
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "#F5F5F5",
          "& th:first-of-type": {
            borderRadius: "4px 0 0 4px",
          },
          "& th:last-of-type": {
            borderRadius: "0 4px 4px 0",
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&.MuiTableRow-hover:hover": {
            background: theme.palette.grey[50]
          }
        }
      },
    },
  };
}
